import { render, staticRenderFns } from "./CPTemp5.vue?vue&type=template&id=52fadd29&scoped=true&"
import script from "./CPTemp5.vue?vue&type=script&lang=js&"
export * from "./CPTemp5.vue?vue&type=script&lang=js&"
import style0 from "./CPTemp5.vue?vue&type=style&index=0&id=52fadd29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fadd29",
  null
  
)

export default component.exports